<template>
  <div>
    <el-select v-model="self_project_id" filterable placeholder="请选择">
      <el-option
        v-for="item in project_list"
        :key="item.id"
        :label="item.name"
        :value="item.id">
      </el-option>
    </el-select>
  </div>
</template>

<script>
import CommonHelp from "../common/CommonHelp";

export default {
  name: "SelectProject",
  props:{
    contract_area_id:{
      type:Number|String,
      default(){
        return 0;
      }
    },
    project_id:{
      type:Number|String,
      default(){
        return 0;
      }
    }
  },
  model: {
    prop: "project_id", // 定义传递给v-model的那个变量，绑定到哪个属性值上               (默认值value)
    event: "success", // event:什么时候触发v-model行为(让父组件能获取到值)    (默认值input)
  },
  created() {
    this.self_project_id=this.project_id;
    this.getList();
  },
  data(){
    return {
      keyword:"",
      project_list:[],
      self_project_id:"",
      loading: false
    }
  },
  methods:{
    getList(){
      var that=this;
      let where={};
      this.keyword&&(where.name=this.keyword);

      if(this.contract_area_id){
        if(this.contract_area_id.indexOf(',')!==-1){
          let contract_area_ids=this.contract_area_id.split(',')
          where.contract_area_ids=contract_area_ids[contract_area_ids.length-1]
        }else {
          where.contract_area_ids=this.contract_area_id;
        }
      }
      this.project_id&&(where.id=this.project_id);

      // 生成缓存 key
      const cacheKey = JSON.stringify(where);

      // 如果已经有缓存数据，直接使用
      if (CommonHelp.projectListCache[cacheKey]) {
        that.project_list = CommonHelp.projectListCache[cacheKey];
        return;
      }

      // 如果正在加载中，等待加载完成
      if (CommonHelp.projectListLoading[cacheKey]) {
        // 轮询等待加载完成
        const timer = setInterval(() => {
          if (!CommonHelp.projectListLoading[cacheKey]) {
            clearInterval(timer);
            // 使用缓存的数据
            if (CommonHelp.projectListCache[cacheKey]) {
              that.project_list = CommonHelp.projectListCache[cacheKey];
            }
          }
        }, 100);
        return;
      }

      // 设置加载状态
      CommonHelp.projectListLoading[cacheKey] = true;

      CommonHelp.get("Project/getList",{
        where:JSON.stringify(where),
        page: 1,
        page_size: 100
      },res=>{
        // 释放加载状态
        CommonHelp.projectListLoading[cacheKey] = false;

        if(res.code) {
          that.project_list=(res.data||{}).list||[];
          // 缓存结果
          CommonHelp.projectListCache[cacheKey] = that.project_list;
        }
      })
    }
  },
  watch:{
    contract_area_id(n){
      if(n){
        this.getList();
      }else {
        this.project_list=[]
      }
    },
    project_id(n){
      this.self_project_id=n;
    },
    self_project_id(n){
      this.$emit("success",n);
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/Contract/components/SelectProject.vue